// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Decco from "../../../../../../node_modules/decco/src/Decco.mjs";
import * as Js_dict from "../../../../../../node_modules/rescript/lib/es6/js_dict.js";
import * as Js_json from "../../../../../../node_modules/rescript/lib/es6/js_json.js";
import * as Belt_Option from "../../../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as DeccoUtils$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/utils/DeccoUtils.mjs";
import * as FareEstimateForm$PorterinFeature from "../../lead-flow/view/component/form/FareEstimateForm.mjs";

function field_error_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var field_name = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "field_name"), null));
  if (field_name.TAG === /* Ok */0) {
    var message = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "message"), null));
    if (message.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                field_name: field_name._0,
                message: message._0
              }
            };
    }
    var e = message._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".message" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = field_name._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".field_name" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

function t_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var address_error_type = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "address_error_type"), null));
  if (address_error_type.TAG === /* Ok */0) {
    var field_errors = Decco.optionFromJson((function (param) {
            return Decco.arrayFromJson(field_error_decode, param);
          }), Belt_Option.getWithDefault(Js_dict.get(dict$1, "field_errors"), null));
    if (field_errors.TAG === /* Ok */0) {
      var form_error = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "form_error"), null));
      if (form_error.TAG === /* Ok */0) {
        return {
                TAG: /* Ok */0,
                _0: {
                  address_error_type: address_error_type._0,
                  field_errors: field_errors._0,
                  form_error: form_error._0
                }
              };
      }
      var e = form_error._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".form_error" + e.path,
                message: e.message,
                value: e.value
              }
            };
    }
    var e$1 = field_errors._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".field_errors" + e$1.path,
              message: e$1.message,
              value: e$1.value
            }
          };
  }
  var e$2 = address_error_type._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".address_error_type" + e$2.path,
            message: e$2.message,
            value: e$2.value
          }
        };
}

var FormErrorApiModel = {
  field_error_decode: field_error_decode,
  t_decode: t_decode
};

function apiModelToState(data) {
  return {
          address_error_type: data.address_error_type,
          field_errors: Belt_Option.mapWithDefault(data.field_errors, undefined, (function (field_errors) {
                  return field_errors.reduce((function (accumulator, current) {
                                var match = current.field_name;
                                switch (match) {
                                  case "customer_mobile" :
                                      return {
                                              pickup: accumulator.pickup,
                                              drop: accumulator.drop,
                                              name: accumulator.name,
                                              mobile: current.message,
                                              requirement: accumulator.requirement
                                            };
                                  case "frequency" :
                                      return {
                                              pickup: accumulator.pickup,
                                              drop: accumulator.drop,
                                              name: accumulator.name,
                                              mobile: accumulator.mobile,
                                              requirement: current.message
                                            };
                                  case "from_address" :
                                      return {
                                              pickup: current.message,
                                              drop: accumulator.drop,
                                              name: accumulator.name,
                                              mobile: accumulator.mobile,
                                              requirement: accumulator.requirement
                                            };
                                  case "name" :
                                      return {
                                              pickup: accumulator.pickup,
                                              drop: accumulator.drop,
                                              name: current.message,
                                              mobile: accumulator.mobile,
                                              requirement: accumulator.requirement
                                            };
                                  case "to_address" :
                                      return {
                                              pickup: accumulator.pickup,
                                              drop: current.message,
                                              name: accumulator.name,
                                              mobile: accumulator.mobile,
                                              requirement: accumulator.requirement
                                            };
                                  default:
                                    return accumulator;
                                }
                              }), FareEstimateForm$PorterinFeature.inital);
                })),
          form_error: data.form_error
        };
}

function execute(json) {
  return apiModelToState(DeccoUtils$Catalyst.resolveResult(t_decode(json), "FareEstimateErrorApiModel.res"));
}

var FareEstimateErrorMapper = {
  FormErrorApiModel: FormErrorApiModel,
  apiModelToState: apiModelToState,
  execute: execute
};

function execute$1(data) {
  if (typeof data === "number" || data.TAG !== /* UnprocessedEntity */2) {
    return ;
  } else {
    return execute(data._0);
  }
}

export {
  FareEstimateErrorMapper ,
  execute$1 as execute,
}
/* DeccoUtils-Catalyst Not a pure module */
